import { useSelector } from "react-redux";
import {
  getIsOverviewTablesLoading,
  getOverviewTablesById,
  getOverviewTablesForTemplateIds,
} from "./selectors";

export const useIsOverviewTablesLoading = () =>
  useSelector((state) => getIsOverviewTablesLoading(state));

export const useOverviewTablesForTemplateIds = (templateIds: number[]) =>
  useSelector((state) => getOverviewTablesForTemplateIds(state, templateIds));

export const useOverviewTablesById = () => useSelector(getOverviewTablesById);
